<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<h1 class="chapter"><em>Anniversaries</em></h1>
<p class="center"><img alt="" src="OEBPS/images/9-1.png"/></p>
<div class="box">
<h1 class="section">On Our Special Anniversary</h1>
<p class="center"><em>I may not always show you<br/>
And I may not always say<br/>
How much you really mean to me<br/>
In every kind of way</em></p>
<p class="center"><em>So on this special day of ours<br/>
I would like the world to know<br/>
How much I really need you<br/>
And how I truly love you so</em></p>
</div>
<p class="center"><img alt="" src="OEBPS/images/10-1.png"/></p>
<div class="box">
<h2 class="section"><em>tip</em></h2>
<p class="center"><em>You can easily adapt this<br/> verse for any type of<br/> anniversary by changing<br/> the word ‘golden’ and<br/> substituting the number<br/> of years</em></p>
</div>
<div class="box">
<h1 class="section">On Your Golden<br/>Wedding Anniversary</h1>
<p class="center"><em>Fifty glorious years together<br/> Memories recent, many old<br/> May all of them be treasured<br/> For they have turned to gold</em></p>
</div>
<p class="center"><img alt="" src="OEBPS/images/11-1.png"/></p>
<div class="box">
<h1 class="section"><em><span class="big">O</span>n Our Wedding Anniversary</em></h1>
<p class="center"><strong>I wouldn’t change a single day<br/>
That I have spent with you<br/>
There’s love in everything you say<br/>
In everything you do<br/>
You never need to tell me<br/>
How much you love me so<br/>
For every time I look at you<br/>
Your smile just lets me know</strong></p>
</div>
<div class="box">
<h1 class="section">Happy Anniversary Mum &amp; Dad</h1>
<p class="center"><em>The love you have for each other is an inspiration to all of us a firm rock which helped me to be the person I am today proud to call you, Mum and Dad</em></p>
</div>
<div class="box">
<p class="center"><em>Celebrate the love you have for each other<br/> Recapture happy memories long forgotten<br/> Cherish your life together always<br/> On this, your anniversary</em></p>
</div>
<div class="box">
<h1 class="section">On your Silver<br/> Wedding Anniversary</h1>
<p class="center"><em>It seems like only yesterday<br/>
That you both said ‘I do’<br/>
The years have gone so quickly<br/>
And been so kind to you<br/>
Lots of memories to hold on to<br/>
Love and laughter on the way<br/>
Treasure them and one another<br/>
On your Silver Wedding Day</em></p>
</div>
<div class="box">
<p class="center"><em>May this Wedding Anniversary Day bring together a collection of beautiful memories and create dreams of more precious tomorrows</em></p>
</div>
<div class="box">
<p class="center"><em>Each passing year brings me closer to you so close that I can feel what you feel love what you love and know that you were truly heaven sent</em></p>
<h1 class="section">HAPPY ANNIVERSARY DARLING</h1>
</div>
<div class="box">
<p class="center"><em><strong>Just to say……..</strong></em></p>
<p class="center"><em>of all the people in all the world I’m glad I married you Happy Anniversary Darling</em></p>
</div>
<div class="box">
<h1 class="section"><em><span class="big">Y</span>ou’re always there each time for me</em></h1>
<p class="center">When everything goes wrong<br/>
You cheer me up and make me laugh<br/>
You keep our marriage strong</p>
<p class="center">You’re my best friend, my husband<br/>
My lover and much more<br/>
The man I love so very much<br/>
The man that I adore</p>
<p class="center">I’m so glad that you asked me<br/>
Years ago to be your wife<br/>
The one to share your hopes and fears<br/>
The one to share your life</p>
<p class="center">And at this special time of year<br/>
There’s nothing more to say<br/>
Than to wish you all you wish yourself<br/>
On our Anniversary</p>
</div>
<div class="box">
<p class="center"><em>No child could wish for parents<br/>
More loving than you two<br/>
A daughter could not hope for<br/>
More support to see her through<br/>
You laid a firm foundation<br/>
On which to build my life<br/>
So I could be a mother<br/>
A best friend and a wife<br/>
Thank you for being rock solid<br/>
Through the good times and the bad<br/>
But most of all I bless you both<br/>
For being my Mum and Dad</em></p>
<h1 class="section">HAPPY ANNIVERSARY</h1>
</div>
<div class="box">
<p class="center"><strong>Husband/Wife</strong></p>
<p class="center"><em>I love you so, you’re always there<br/>
To comfort me and show you care<br/>
I know you always understand<br/>
I feel upset, you touch my hand<br/>
You are my reason to exist<br/>
I knew that moment we first kissed<br/>
I cherish our anniversary<br/>
The day on which you married me<br/>
You are the person I adore<br/>
So here’s to many, many more</em></p>
<h1 class="section">Happy Anniversary Darling</h1>
</div>
<div class="box">
<p class="center"><em>Marriage is a priceless gift<br/>
That makes two people one<br/>
That binds them with a love so strong<br/>
To help them carry on</em></p>
<p class="center"><em>Through ups and downs life hands them<br/>
Happy days and sometimes sad<br/>
That helps them to discover<br/>
What it’s like as Mum and Dad</em></p>
<p class="center"><em>To build a world together<br/>
A precious family of their own<br/>
To find a house together<br/>
That then becomes a home</em></p>
<p class="center"><em>Marriage is a treasure<br/>
That can’t be bought or sold<br/>
It’s a partnership together<br/>
Which, with the years, can turn to gold</em></p>
<h1 class="section">HAPPY GOLDEN WEDDING</h1>
</div>
<p class="center"><img alt="" src="OEBPS/images/16-1.png"/></p>
<div class="box">
<p class="center"><em><strong>Just to say……..</strong></em></p>
<p class="center"><em>you made two half families into a great whole one Happy Anniversary to you both from all of your children</em></p>
</div>
<div class="box">
<p class="center"><em>Life is not always easy but being with you and sharing our lives is a pleasure that I hope will last forever</em></p>
</div>
<p class="center"><em>You really are an angel<br/>
With everyone you meet<br/>
You’re the wife I always dreamed of<br/>
You make my life complete</em></p>
<h1 class="section">HAPPY ANNIVERSARY</h1>
<div class="box">
<h1 class="section">HAPPY ANNIVERSARY HUSBAND</h1>
<p class="center"><em>Reflections in the water on a lovely sunny day<br/>
Remind me of the day we met and I’d just like to say<br/>
You fill my life with sunshine like a thousand sparkling beams<br/>
You’re my knight in shining armour, the answer to my dreams<br/>
The day we wed seems distant, so far away and yet<br/>
It was magical, a fairytale, a day I won’t forget<br/>
For me it was so special, the beginning of my life<br/>
I’m proud of you my husband, proud to be your wife</em></p>
</div>
<div class="box">
<h2 class="section"><em>tip</em></h2>
<p class="center"><em>Insert the number of years that the couple have been married in the first line, to make it specific to the anniversary</em></p>
</div>
<div class="box">
<h1 class="section"><em><span class="big">S</span>on &amp; Daughter-in-law</em></h1>
<p class="center"><strong><em>Or Daughter &amp; Son-in-law</em></strong></p>
<p class="center">Three years you’ve spent together<br/>
As devoted man and wife<br/>
And now somebody special<br/>
Is about to share your life<br/>
You’re a really lovely couple<br/>
Who both of us adore<br/>
About to make us ‘grand’ parents<br/>
Well who could ask for more<br/>
So on your anniversary<br/>
We wish you both good cheer<br/>
For your wedding celebrations<br/>
And throughout the coming year</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c01.vue?4edd0a78